import React from "react"
import styled from "styled-components"

import "react-toastify/dist/ReactToastify.css"

import Decoration from "./Decoration"
import PositionAndWidth from "./PositionAndWidth"

import Button from "./Button"

import {
  BGWrapper,
  H2,
  H3,
  DescWrapper,
  TextRow,
  StrongT,
  ButtonsWrapper
} from "./UIStyle/UIstyle"
import { theme } from "@/containers/LuckyBagNew2023/Views/mixin"
import Bonus2 from "./animationIMG/Bonus2"

export default function BonusSecond() {
  return (
    <>
      <Wrapper id="top" bg={theme.bgLinearBottom}>
        <ContentWrapper>
          <BGWrapper>
            <PositionAndWidth
              d={{ width: "10%", b: "0%", l: "20%" }}
              m={{ width: "clamp(30px,40%,120px)", b: "-1%", r: "0%" }}
            >
              <Decoration
                type="blobman1"
                animation="updown"
                time={12}
                delay={0}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "10%", b: "0%", l: "-3%" }}
              m={{ width: "clamp(30px,40%,120px)", b: "0%", l: "-3%" }}
            >
              <Decoration
                type="blobman2"
                animation="updown"
                time={12}
                delay={6}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "8%", b: "0px", r: "0%" }}
              m={{ width: "0%", b: "0px", r: "10%" }}
            >
              <Decoration
                type="blobman1"
                animation="updown"
                time={12}
                delay={4}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "4%", t: "15%", r: "-2%" }}
              m={{ width: "8%", t: "40%", l: "-4%" }}
            >
              <Decoration
                type="circle"
                animation="updown"
                time={12}
                delay={3}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "1%", t: "50%", r: "-0.5%" }}
              m={{ width: "3%", t: "50%", r: "-1.5%" }}
            >
              <Decoration
                type="Scircle"
                animation="updown"
                time={12}
                delay={9}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "1.5%", b: "-0.75%", l: "40%" }}
              m={{ width: "3%", b: "-0%", l: "40%" }}
            >
              <Decoration
                type="Scircle"
                animation="updown"
                time={12}
                delay={2}
              />
            </PositionAndWidth>
          </BGWrapper>
          <LeftWrapper>
            <TitleText>
              <H3>BONUS !!</H3>
              <H2>
                <span>分享活動貼文再抽 !</span>
              </H2>
            </TitleText>
            <DescWrapper>
              <TextRow>
                <StrongT nowrap>任務條件：</StrongT>
                <StrongT>分享 KryptoGO 官方活動貼文</StrongT>
              </TextRow>
              <TextRow>
                <StrongT nowrap>活動獎項：</StrongT>
                <StrongT>AirPods 3 、iPad 10</StrongT>
              </TextRow>
              <TextRow>
                <StrongT nowrap>開獎時間：</StrongT>
                <StrongT>於4/10（一）下午六點抽出、聯繫得獎者</StrongT>
              </TextRow>
            </DescWrapper>
            <ButtonsWrapper>
              <Button
                content="參加抽獎"
                arrow
                blank
                href="https://www.facebook.com/kryptogo/posts/pfbid02eFJL9G8fQGXGpZVYcijpaes67eRbNXrASoi4Ep26yVgYkELK8p8eq1YCFLk2uNU5l"
                id="toybox-bonus2Button1"
              />
            </ButtonsWrapper>
          </LeftWrapper>
          <RightWrapper>
            <HeroWrapper>
              <Bonus2 />
            </HeroWrapper>
          </RightWrapper>
        </ContentWrapper>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding: 60px 60px 60px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ bg }) => bg};
  height: clamp(750px, 100vh, 1000px);

  @media (${theme.xl}) {
    height: clamp(100%, 100vh, 100%);
  }
  @media (${theme.md}) {
    padding: 20px 20px 50px 20px;
  }
`

const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  background-color: #fff;
  border-radius: 73px;
  width: 100%;
  max-width: 1600px;
  height: 100%;
  gap: 40px;
  padding: 60px 60px 60px 60px;
  align-items: center;
  justify-content: start;
  @media (${theme.xl}) {
    padding: 30px 30px 30px 30px;
    border-radius: 36px;
    justify-content: center;
    align-items: center;
  }
  @media (${theme.lg}) {
    padding: 30px 30px 80px 30px;
    gap: 0px;
    border-radius: 36px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  @media (${theme.md}) {
    padding: 60px 20px 80px 20px;
    gap: 20px;
  }
`

const LeftWrapper = styled.div`
  text-align: start;
  display: flex;
  flex: 1.2;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 24px;
  border-radius: 50px;
  z-index: 30;
  order: 0;
  @media (${theme.lg}) {
    padding: 0px 0px;
    justify-content: start;
    order: 2;
  }
  @media (${theme.md}) {
    padding: 0px;
    width: 100%;
    order: 2;
    justify-content: center;
    align-items: center;
  }
  @media (${theme.sm}) {
    width: 100%;
  }
`
const TitleText = styled.div`
  font-family: "Barlow", "Noto Sans TC", sans-serif;
  text-align: start;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  gap: 8px;
  @media (${theme.md}) {
    align-items: center;
  }
`

const A = styled.div``

// 右邊區域
const RightWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  flex: 1;
  order: 0;

  @media (${theme.xl}) {
    width: 50%;
  }
  @media (${theme.lg}) {
    width: 100%;
  }

  @media (${theme.md}) {
    position: relative;
    top: 0;
    width: 100%;
    padding: 0px;
    order: 0;
    transform: translate(0, 0%);
  }
`

const HeroWrapper = styled.div`
  width: 100%;
  @media (${theme.lg}) {
    max-width: 400px;
  }
  @media (${theme.md}) {
    max-width: 300px;
  }
  @media (${theme.sm}) {
    max-width: 300px;
  }
`
const B = styled.div``

const MobileLOGOsWrapper = styled.div``
